import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getLenderState } from 'store/selectors/lenders.selector';
import { AppDispatch } from 'store/store';
import { getBalloonMaxOdometersThunk } from 'actions/vehicleActions';
import { getControlImagesThunk } from 'actions/controlActions';
import { setBalloonInitDataLoaded } from 'store/reducers/lenders.reducer';

export const useRequestBalloonInitData = (areRequiredFieldsFilled: boolean) => {
  const dispatch: AppDispatch = useDispatch();
  const lenderState = useSelector(getLenderState);
  const { id: lenderId } = lenderState;
  const [isInitDataRequestAllowed, setIsInitDataRequestAllowed] = useState(true);

  const requestBalloonInitData = async () => {
    await Promise.all([dispatch(getBalloonMaxOdometersThunk()), dispatch(getControlImagesThunk())]);
    dispatch(setBalloonInitDataLoaded(true));
  };

  useEffect(() => {
    if (!!lenderState?.afg && !!lenderState?.afg_id && areRequiredFieldsFilled && isInitDataRequestAllowed) {
      requestBalloonInitData();
      setIsInitDataRequestAllowed(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lenderId, lenderState?.afg, lenderState?.afg_id, dispatch, areRequiredFieldsFilled]);
};
